// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, logEvent } from "firebase/analytics"; // ✅ Added for analytics

const firebaseConfig = {
  apiKey: "AIzaSyCq44ZQcLAU1Td9VgYX99TsBvXuEDMbwNs",
  authDomain: "phoneregister-e8579.firebaseapp.com",
  projectId: "phoneregister-e8579",
  storageBucket: "phoneregister-e8579.firebasestorage.app",
  messagingSenderId: "835805526718",
  appId: "1:835805526718:web:4e9de8fe8891a1bbcf7cef",
  measurementId: "G-GYC41EMH9R",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// ✅ Initialize analytics only if window is defined (to avoid SSR issues)
let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export { auth, analytics, logEvent }; // ✅ Export analytics and logEvent
